import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';
import { getSolidBackgroundShade } from 'utils/ui/colors';
import Text from 'components/Text';
import Landmark from 'components/Landmark';
import ErrorBoundary from 'components/ErrorBoundary';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LoaderBG = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'transitionDuration';
  }
}).withConfig({
  displayName: "ErrorAndLoadingWrapper__LoaderBG",
  componentId: "sc-s9qcfw-0"
})(["position:absolute;top:0;left:0;width:100%;height:100%;background:", ";transition:opacity ", "ms ease-out;&.fade-enter{opacity:0;}&.fade-enter-active{opacity:1;}&.fade-enter-done{opacity:1;}&.fade-exit{opacity:1;}&.fade-exit-active{opacity:0;}&.fade-exit-done{opacity:0;}"], function (p) {
  return getSolidBackgroundShade(p.theme);
}, function (p) {
  return p.transitionDuration;
});
var Overlay = function Overlay(_ref) {
  var isVisible = _ref.isVisible,
    _ref$transitionDurati = _ref.transitionDuration,
    transitionDuration = _ref$transitionDurati === void 0 ? 200 : _ref$transitionDurati,
    children = _ref.children;
  var nodeRef = React.useRef(null);
  return /*#__PURE__*/_jsx(CSSTransition, {
    nodeRef: nodeRef,
    unmountOnExit: true,
    in: isVisible,
    timeout: transitionDuration,
    classNames: "fade",
    children: /*#__PURE__*/_jsx(LoaderBG, {
      ref: nodeRef,
      transitionDuration: transitionDuration,
      children: children
    })
  });
};
var Loader = function Loader(_ref2) {
  var isVisible = _ref2.isVisible;
  return /*#__PURE__*/_jsx(Overlay, {
    isVisible: isVisible,
    children: /*#__PURE__*/_jsx(Landmark, {
      icon: "spinner"
    })
  });
};
function Error(_ref3) {
  var error = _ref3.error;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _error$message = error.message,
    message = _error$message === void 0 ? t('error_generic') : _error$message,
    code = error.code;
  return /*#__PURE__*/_jsx(Overlay, {
    isVisible: !!error,
    children: /*#__PURE__*/_jsxs(Landmark, {
      icon: "flag",
      children: [/*#__PURE__*/_jsx("p", {
        children: message
      }), code && /*#__PURE__*/_jsxs(Text, {
        as: "p",
        mt: "m",
        children: [t('error_code'), ": ", /*#__PURE__*/_jsx("b", {
          children: error.code
        })]
      })]
    })
  });
}
function ErrorAndLoadingWrapper(_ref4) {
  var children = _ref4.children,
    error = _ref4.error,
    isReady = _ref4.isReady;
  return /*#__PURE__*/_jsxs(ErrorBoundary, {
    children: [/*#__PURE__*/_jsx(Loader, {
      isVisible: !error && !isReady
    }), error ? /*#__PURE__*/_jsx(Error, {
      error: error
    }) : children]
  });
}
export default ErrorAndLoadingWrapper;